export const MENTION_PREVIEW_OPEN_DELAY_MS = 180
const PREVIEW_SIZE_PX = 136
const PREVIEW_PAD_PX = 8
const PREVIEW_GAP_PX = 8

/** Viewport box for `.pe-mention__preview`: 8px above the thumb, flipped below if it would clip. */
export function placeMentionThumbPreview(anchor: DOMRect): { top: number; left: number } {
  const size = PREVIEW_SIZE_PX
  const pad = PREVIEW_PAD_PX
  let top = anchor.top - size - PREVIEW_GAP_PX
  let left = anchor.left + anchor.width / 2 - size / 2
  if (left < pad) left = pad
  if (left + size > window.innerWidth - pad) {
    left = Math.max(pad, window.innerWidth - pad - size)
  }
  if (top < pad) {
    top = Math.min(window.innerHeight - pad - size, anchor.bottom + PREVIEW_GAP_PX)
  }
  return { top, left }
}
